module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/messageforums/bravenet_messageforums_easy_style_builder.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/messageforums/bravenet_messageforums_easy_style_builder.png
// module id = p2G7
// module chunks = 0